// Wo steht das in Quaro? Ordnet einen Tool-Aufruf des Chats einer Seite zu: Route, Weg in Worten und Menuepunkt. Zwei Nutzer:
// die Sources-Zeile im Chat ("Open in Quaro") und der Cursor von "Follow the AI". Tools ohne Eintrag haben keine Seite in Quaro
// (SEO-Livedaten, reine Hilfsabfragen, kuenftige Tools) - lieber kein Link als ein falscher. Reines Modul ohne Vue.
const ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/

const AI_SECTION_BY_TOOL = {
    create_ai_project: "",
    get_ai_project_dates: "",
    get_brand_visibility_timeseries: "",
    search_project_entities: "",
    update_ai_project: "",
    add_ai_project_platforms: "",
    get_ai_prompts: "prompts",
    get_prompt_overview: "prompts",
    add_ai_prompts: "prompts",
    delete_ai_prompts: "prompts",
    set_ai_prompt_tags: "prompts",
    list_ai_project_tags: "prompts",
    get_brand_mentions: "mentions",
    get_brands_snapshot_latest_day: "brands",
    get_brands_ranking_single_day: "brands",
    get_all_brands_kpis_range: "brands",
    get_single_brand_kpis_range: "brands",
    get_brand_performance_by_platform: "brands",
    get_brand_performance_by_tag: "brands",
    get_top_brands_by_tag: "brands",
    get_cited_sources: "sources",
    get_source_page_types: "sources",
    get_fanout_queries: "fanout",
    list_ai_project_reports: "reports",
    get_ai_project_report: "reports",
    create_ai_project_report: "reports",
    update_ai_project_report: "reports",
    delete_ai_project_report: "reports",
    publish_ai_project_report: "reports",
    unpublish_ai_project_report: "reports"
}
// Kachel auf dem AI-Dashboard; Abschnitts-Tools zeigen auf die Tabelle ihres Abschnitts ("section").
const AI_TILE_BY_TOOL = { get_brand_visibility_timeseries: "visibility-chart" }
const AI_SECTION_LABEL = { "": "Dashboard", prompts: "Prompts", mentions: "Mentions", brands: "Brands", sources: "Sources", fanout: "Fanout queries", reports: "Reports" }
// Danach gibt es die Projektseite nicht (mehr) - immer die Liste.
const AI_LIST_TOOLS = ["list_ai_projects", "delete_ai_project"]
// Vorbereitende Abfrage ohne eigene Aussage: hat einen Link, bewegt aber den Cursor nicht.
const FOLLOW_SKIP_TOOLS = ["get_ai_project_dates"]

const MONITORING_LIST_TOOLS = [
    "list_monitoring_projects",
    "delete_monitoring_project",
    "list_monitoring_folders",
    "create_monitoring_folder",
    "update_monitoring_folder",
    "delete_monitoring_folder",
    "get_rankings_for_keywords"
]
// Ansicht auf der Projektseite: tab = Tabelle unten, chart = Diagramm oben (MonitoringProject.vue, applyDeepLinkView).
const MONITORING_VIEW_BY_TOOL = {
    create_monitoring_project: { label: "" },
    get_project_rankings: { tab: "Rankings", label: "Rankings" },
    get_monitoring_project_keywords: { tab: "Rankings", label: "Rankings" },
    add_monitoring_project_keywords: { tab: "Rankings", label: "Rankings" },
    delete_monitoring_project_keywords: { tab: "Rankings", label: "Rankings" },
    get_project_keyword_trends: { tab: "Trends", label: "Trends" },
    get_project_category_breakdown: { tab: "Categories", label: "Categories" },
    list_monitoring_project_categories: { tab: "Categories", label: "Categories" },
    create_monitoring_project_category: { tab: "Categories", label: "Categories" },
    delete_monitoring_project_category: { tab: "Categories", label: "Categories" },
    assign_monitoring_project_category: { tab: "Categories", label: "Categories" },
    get_category_search_volume_trends: { tab: "Categories", label: "Categories" },
    get_project_keyword_cluster: { tab: "Cluster", label: "Cluster" },
    list_project_keyword_clusters: { tab: "Cluster", label: "Cluster" },
    get_monitoring_competitors: { tab: "Competitors", label: "Competitors" },
    get_top_monitoring_competitors: { tab: "Competitors", label: "Competitors" },
    discover_monitoring_competitors: { tab: "Competitors", label: "Competitors" },
    search_monitoring_competitors_by_domain: { tab: "Competitors", label: "Competitors" },
    get_hidden_competitors: { tab: "Competitors", label: "Competitors" },
    add_hidden_competitors: { tab: "Competitors", label: "Competitors" },
    delete_hidden_competitors: { tab: "Competitors", label: "Competitors" },
    get_project_visibility_history: { chart: "Visibility", label: "Visibility chart" },
    get_project_visibility_by_domain: { chart: "Visibility", label: "Visibility chart" },
    compare_competitor_visibility: { chart: "Visibility", label: "Visibility chart" },
    get_competitor_visibility_chart: { chart: "Visibility", label: "Visibility chart" },
    get_competitor_domain_visibility_history: { chart: "Visibility", label: "Visibility chart" },
    get_project_serp_features: { chart: "SERPTypes", label: "SERP types chart" },
    get_project_shopping_sellers: { chart: "SERPTypes", label: "SERP types chart" },
    get_seller_shopping_visibility: { chart: "SERPTypes", label: "SERP types chart" },
    get_keyword_ai_overview: { chart: "AIOs", label: "AI overviews chart" },
    update_monitoring_project: { label: "" }
}

// Content-Projektseiten. editor: nur als Link - er sperrt das Dokument (Lease), der Cursor oeffnet ihn deshalb nie.
const CONTENT_PAGE_BY_TOOL = {
    create_content_project: { page: "setup" },
    setup_content_project: { page: "briefing" },
    run_content_project_setup: { page: "briefing" },
    get_content_project: { page: "briefing" },
    update_content_project: { page: "briefing" },
    get_content_project_briefing: { page: "briefing" },
    get_content_project_keywords: { page: "briefing" },
    setup_content_project_questions: { page: "setup" },
    setup_content_project_terms: { page: "setup" },
    setup_content_project_topics: { page: "setup" },
    setup_content_project_competitors: { page: "setup" },
    publish_content_project_section: { page: "briefing" },
    unpublish_content_project_section: { page: "briefing" },
    get_content_project_workflow: { page: "briefing", label: "Briefing (workflow in the header)" },
    create_content_workflow: { page: "briefing", label: "Briefing (workflow in the header)" },
    update_content_workflow: { page: "briefing", label: "Briefing (workflow in the header)" },
    delete_content_workflow: { page: "briefing", label: "Briefing (workflow in the header)" },
    set_content_workflow_stage: { page: "briefing", label: "Briefing (workflow in the header)" },
    add_content_workflow_stage: { page: "briefing", label: "Briefing (workflow in the header)" },
    remove_content_workflow_stage: { page: "briefing", label: "Briefing (workflow in the header)" },
    add_content_workflow_task: { page: "briefing", label: "Briefing (workflow in the header)" },
    remove_content_workflow_task: { page: "briefing", label: "Briefing (workflow in the header)" },
    assign_content_workflow_task: { page: "briefing", label: "Briefing (workflow in the header)" },
    complete_content_workflow_task: { page: "briefing", label: "Briefing (workflow in the header)" },
    comment_on_content_workflow_task: { page: "briefing", label: "Briefing (workflow in the header)" },
    get_content_project_editor: { page: "editor" },
    save_content_project_editor: { page: "editor" },
    generate_content_text: { page: "editor" },
    generate_article_from_outline: { page: "editor" }
}
const CONTENT_PAGES = {
    briefing: { path: (id) => "/briefing/" + id, label: "Briefing" },
    wdf: { path: (id) => "/content-project/wdf-idf/" + id, label: "WDF*IDF" },
    competitors: { path: (id) => "/content-project/competitors/" + id, label: "Competitors" },
    setup: { path: (id) => "/content-project/setup?id=" + id, label: "Setup" },
    editor: { path: (id) => "/content-editor/" + id, label: "Editor", linkOnly: true }
}
const CONTENT_LIST_TOOLS = ["list_content_projects", "delete_content_project", "list_content_folders", "create_content_folder", "update_content_folder", "delete_content_folder"]

// Die Detailseite einer Collection braucht den Namen, keine ID: Argument "collection", beim Anlegen "name", beim Umbenennen "new_name".
const COLLECTION_DETAIL_TOOLS = [
    "create_research_collection",
    "rename_research_collection",
    "get_research_collection",
    "add_collection_keywords",
    "delete_collection_keywords",
    "categorize_collection_keywords",
    "list_collection_columns",
    "create_collection_column",
    "delete_collection_column",
    "set_collection_column_value",
    "publish_research_collection",
    "unpublish_research_collection"
]
const COLLECTION_LIST_TOOLS = [
    "list_research_collections",
    "delete_research_collection",
    "list_research_projects",
    "create_research_project",
    "update_research_project",
    "delete_research_project",
    "assign_collection_to_research_project",
    "remove_collection_from_research_project"
]
const RESEARCH_PAGE_BY_TOOL = {
    get_keyword_ideas: { route: "/ideas", label: "Keyword Ideas" },
    get_keywords_for_domain: { route: "/ideas", label: "Keyword Ideas" },
    get_keywords_for_url: { route: "/ideas", label: "Keyword Ideas" },
    get_keyword_difficulty: { route: "/ideas", label: "Keyword Ideas" },
    get_search_intent: { route: "/ideas", label: "Keyword Ideas" },
    get_autocomplete_suggestions: { route: "/suggests", label: "Suggests" },
    get_google_search_volume: { route: "/searchvolume", label: "Search Volume" },
    get_quaro_search_volume: { route: "/searchvolume", label: "Search Volume" }
}
const SETTINGS_BY_TOOL = {
    get_account_credits: { tab: "credits", label: "Credit Overview", adminOnly: true },
    get_account_me: { tab: "account", label: "Account", adminOnly: true },
    get_gsc_performance: { tab: "integrations", label: "Integrations (Search Console)" },
    inspect_gsc_url: { tab: "integrations", label: "Integrations (Search Console)" },
    list_gsc_properties: { tab: "integrations", label: "Integrations (Search Console)" },
    list_gsc_sitemaps: { tab: "integrations", label: "Integrations (Search Console)" }
}

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key)

function parseArguments(args) {
    if (args && typeof args === "object") return args
    if (typeof args !== "string" || !args) return {}
    try {
        const parsed = JSON.parse(args)
        return parsed && typeof parsed === "object" ? parsed : {}
    } catch (error) {
        return {}
    }
}

function validId(value) {
    const text = typeof value === "number" ? String(value) : value
    return typeof text === "string" && ID_PATTERN.test(text) ? text : null
}

// Anlege-Tools kennen die neue ID erst nach dem Aufruf: sie steht in der Antwort (data.project_id).
const CREATING_TOOLS = ["create_monitoring_project", "create_ai_project", "create_content_project", "setup_content_project"]
function createdProjectId(tool, output) {
    if (!CREATING_TOOLS.includes(tool) || !output || typeof output !== "object") return null
    const data = output.data && typeof output.data === "object" ? output.data : output
    return validId(data.project_id)
}

// Ein gerade angelegtes Projekt steht in keiner Listenantwort des Chats: Name fuer die Folgezeilen (ID -> Titel) aus dem Anlege-Aufruf.
export function addCreatedProjectNames(idNames, tables) {
    for (const table of Array.isArray(tables) ? tables : []) {
        const id = table && createdProjectId(table.name, table.rawOutput)
        const title = id ? parseArguments(table.arguments).title : null
        if (id && typeof title === "string" && title.trim() && !idNames.has(id)) idNames.set(id, title.trim())
    }
    return idNames
}

// Suchbegriffe einer Keyword-Recherche: die Seite wird damit vorbelegt, ohne die (kostenpflichtige) Suche zu starten.
function researchKeywords(args) {
    const raw = Array.isArray(args.keywords) ? args.keywords : typeof args.keywords === "string" ? args.keywords.split(/[,\n]/) : typeof args.keyword === "string" ? [args.keyword] : []
    return raw
        .filter((keyword) => typeof keyword === "string")
        .map((keyword) => keyword.trim())
        .filter(Boolean)
        .slice(0, 200)
}

// tool + Aufruf-Argumente -> { route, navHref, crumbs, linkOnly?, sendKeywords? } oder null. options.projectName(id) liefert den Namen zur
// ID, options.isAdmin blendet Ziele aus, die nur Admins sehen, options.output ist die Antwort des Aufrufs (neue ID beim Anlegen).
export function resolveToolTarget(tool, rawArgs, options) {
    if (typeof tool !== "string") return null
    const args = parseArguments(rawArgs)
    const projectId = validId(args.project_id) || createdProjectId(tool, options && options.output)
    const givenTitle = typeof args.title === "string" && args.title.trim() ? args.title.trim() : "Project"
    const projectName = () => (options && options.projectName && projectId && options.projectName(projectId)) || givenTitle

    if (AI_LIST_TOOLS.includes(tool)) return { navHref: "/ai-suite", route: "/ai-suite", crumbs: ["AI Suite", "Projects"], follow: { list: "/ai-suite" } }
    if (hasOwn(AI_SECTION_BY_TOOL, tool)) {
        if (!projectId) return { navHref: "/ai-suite", route: "/ai-suite", crumbs: ["AI Suite", "Projects"], follow: { list: "/ai-suite" } }
        const section = AI_SECTION_BY_TOOL[tool]
        return {
            follow: {
                list: "/ai-suite",
                rowId: projectId,
                project: "/ai-suite/project/" + projectId,
                tab: "ai:" + (section || "dashboard"),
                tile: AI_TILE_BY_TOOL[tool] || (section && section !== "reports" ? "section" : null)
            },
            navHref: "/ai-suite",
            route: "/ai-suite/project/" + projectId + (section ? "/" + section : ""),
            crumbs: ["AI Suite", projectName(), AI_SECTION_LABEL[section]],
            multiLabel: AI_SECTION_LABEL[section]
        }
    }

    if (MONITORING_LIST_TOOLS.includes(tool)) return { navHref: "/monitoring", route: "/monitoring", crumbs: ["Monitoring", "Projects"], follow: { list: "/monitoring" } }
    if (hasOwn(MONITORING_VIEW_BY_TOOL, tool)) {
        if (!projectId) return { navHref: "/monitoring", route: "/monitoring", crumbs: ["Monitoring", "Projects"], follow: { list: "/monitoring" } }
        const view = MONITORING_VIEW_BY_TOOL[tool]
        const query = []
        if (view.tab) query.push("tab=" + view.tab)
        if (view.chart) query.push("chart=" + view.chart)
        return {
            follow: {
                list: "/monitoring",
                rowId: projectId,
                project: "/monitoring/project/" + projectId,
                tab: view.tab ? "mon:" + view.tab : view.chart ? "monchart:" + view.chart : null,
                tile: view.tab ? "table" : view.chart ? "chart" : null
            },
            navHref: "/monitoring",
            route: "/monitoring/project/" + projectId + (query.length ? "?" + query.join("&") : ""),
            crumbs: ["Monitoring", projectName()].concat(view.label ? [view.label] : []),
            multiLabel: view.label
        }
    }

    if (CONTENT_LIST_TOOLS.includes(tool)) return { navHref: "/content-projects", route: "/content-projects", crumbs: ["Content", "Projects"] }
    if (tool === "run_wdfidf_analysis") return { navHref: "/wdf-idf", route: "/wdf-idf", crumbs: ["Content", "WDF*IDF"] }
    if (hasOwn(CONTENT_PAGE_BY_TOOL, tool)) {
        if (!projectId) return { navHref: "/content-projects", route: "/content-projects", crumbs: ["Content", "Projects"] }
        const entry = CONTENT_PAGE_BY_TOOL[tool]
        const page = CONTENT_PAGES[entry.page]
        const label = entry.label || page.label
        const target = { navHref: "/content-projects", route: page.path(projectId), crumbs: ["Content", projectName(), label], multiLabel: label }
        target.follow = { list: "/content-projects", project: page.path(projectId).split("?")[0] }
        if (page.linkOnly) target.linkOnly = true
        return target
    }

    if (COLLECTION_LIST_TOOLS.includes(tool)) return { navHref: "/collections", route: "/collections", crumbs: ["Research", "Collections"] }
    if (COLLECTION_DETAIL_TOOLS.includes(tool)) {
        const given = [args.new_name, args.collection, args.name].find((value) => typeof value === "string" && value.trim())
        const name = given ? given.trim() : ""
        if (!name) return { navHref: "/collections", route: "/collections", crumbs: ["Research", "Collections"] }
        return { navHref: "/collections", route: "/research/" + encodeURIComponent(name), crumbs: ["Research", "Collections", name], follow: { list: "/collections", project: "/research/" + encodeURIComponent(name) } }
    }
    if (hasOwn(RESEARCH_PAGE_BY_TOOL, tool)) {
        const page = RESEARCH_PAGE_BY_TOOL[tool]
        const keywords = researchKeywords(args)
        const crumbs = ["Research", page.label]
        if (keywords.length) crumbs.push(keywords[0] + (keywords.length > 1 ? " +" + (keywords.length - 1) : ""))
        const target = { navHref: page.route, route: page.route, crumbs, follow: { list: page.route, tile: "search" } }
        if (keywords.length) target.sendKeywords = keywords
        return target
    }

    if (hasOwn(SETTINGS_BY_TOOL, tool)) {
        const entry = SETTINGS_BY_TOOL[tool]
        if (entry.adminOnly && !(options && options.isAdmin)) return null
        return { navHref: "/settings", route: "/settings?tab=" + entry.tab, crumbs: ["Settings", entry.label], settings: true }
    }
    return null
}

// Fehlgeschlagene Aufrufe (Envelope mit Fehlercode) zeigen auf nichts: das Objekt gibt es vielleicht gar nicht.
function isFailedOutput(output) {
    if (!output || typeof output !== "object") return false
    const code = Number(output.status_code)
    return Number.isFinite(code) && code >= 400
}

// Alle Aufrufe einer Sources-Zeile -> { targets: [{route, label}], place: "Monitoring › Shop › Rankings" }. Gleiche Ziele nur einmal.
export function describeSourcePlaces(tables, options) {
    const byRoute = new Map()
    for (const table of Array.isArray(tables) ? tables : []) {
        if (!table || isFailedOutput(table.rawOutput)) continue
        const target = resolveToolTarget(table.name, table.arguments, { ...options, output: table.rawOutput })
        // Gleiche Seite, andere Suchbegriffe (zwei Recherchen): eigene Zeile, sonst ginge der zweite Begriff verloren.
        const key = target ? target.route + "|" + (target.sendKeywords || []).join(",") : ""
        if (target && !byRoute.has(key)) byRoute.set(key, { ...target, key, projectId: validId(parseArguments(table.arguments).project_id) })
    }
    const all = [...byRoute.values()]
    if (!all.length) return { targets: [], place: "" }
    if (all.length === 1) return { targets: [{ key: all[0].key, route: all[0].route, sendKeywords: all[0].sendKeywords, label: all[0].crumbs.join(" › ") }], place: all[0].crumbs.join(" › ") }
    const suite = all[0].crumbs[0]
    const sameSuite = all.every((target) => target.crumbs[0] === suite)
    const section = all[0].multiLabel
    const sameSection = section && all.every((target) => target.multiLabel === section)
    const place = !sameSuite ? all.length + " pages" : suite + " › " + all.length + " pages" + (sameSection ? " › " + section : "")
    const labelOf = (target) => target.crumbs.slice(sameSuite ? 1 : 0).join(" › ")
    const labels = all.map(labelOf)
    // Zwei Projekte ohne bekannten Namen saehen im Menue gleich aus: dann mit Kurz-ID unterscheiden.
    const shown = (target) => (labels.filter((label) => label === labelOf(target)).length > 1 && target.projectId ? labelOf(target) + " (id " + target.projectId.slice(0, 8) + ")" : labelOf(target))
    return { targets: all.map((target) => ({ key: target.key, route: target.route, sendKeywords: target.sendKeywords, label: shown(target) })), place }
}

// Cursor von "Follow the AI": nur fertige Quaro-Aufrufe, nie der Editor, Einstellungen oder vorbereitende Abfragen.
export function resolveFollowTarget(step) {
    if (!step || step.source !== "quaro" || step.state !== "done" || FOLLOW_SKIP_TOOLS.includes(step.tool)) return null
    const target = resolveToolTarget(step.tool, { ...(step.ids || {}), keywords: step.keywords }, { isAdmin: false })
    if (!target || target.linkOnly || target.settings) return null
    return target
}

// Gleicher Text wie im Schritt-Feed des Chats: den Anbieter der SEO-Daten nennt die Oberflaeche nie.
export function followStepLabel(step) {
    if (!step) return ""
    if (step.source === "seo") return "SEO data lookup"
    if (!step.tool) return "Working on your data"
    const text = String(step.tool).split("_").filter(Boolean).join(" ")
    return text.charAt(0).toUpperCase() + text.slice(1)
}

const FOLLOW_STORAGE_KEY = "ai_follow_chat"

export function followWanted() {
    try {
        return localStorage.getItem(FOLLOW_STORAGE_KEY) === "1"
    } catch (error) {
        return false
    }
}

export function setFollowWanted(value) {
    try {
        localStorage.setItem(FOLLOW_STORAGE_KEY, value ? "1" : "0")
    } catch (error) {
        // ohne Speicher gilt der Schalter nicht ueber den Reload hinaus
    }
}

// Der neue Modus ist fertig erst, wenn dieser Schalter in der .env gesetzt ist - ohne ihn erscheint nichts davon.
export function followAvailable() {
    return process.env.VUE_APP_AI_FOLLOW === "true"
}

export function reducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
}
